import { Svg } from './svg'

export const HelpIcon = () => (
  <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.85002 9.25H7.09002C7.09002 8.56075 7.5948 8.09866 8.0637 7.66941C8.47035 7.29715 8.85002 6.94959 8.85002
      6.5C8.85002 6.115 8.59702 5.862 8.03602 5.862C7.43102 5.862 7.06802 6.269 6.84802 6.786L5.33002 5.917C5.81402
      4.784 6.88102 4.146 8.10202 4.146C9.35602 4.146 10.61 4.916 10.61 6.346C10.61 7.3213 9.98681 7.89541 9.48209
      8.36037C9.13862 8.67678 8.85002 8.94265 8.85002 9.25Z"
      fill="currentColor"
    />
    <path
      d="M9.01502 11.109C9.01502 11.681 8.54202 12.154 7.97002 12.154C7.39802 12.154 6.92502 11.681 6.92502
    11.109C6.92502 10.537 7.39802 10.064 7.97002 10.064C8.54202 10.064 9.01502 10.537 9.01502 11.109Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172
     3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629
     2 8 2C11.3137 2 14 4.68629 14 8Z"
      fill="currentColor"
    />
  </Svg>
)
